import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SimTextareaAutosizeDirective } from './autosize.directive';
import { SimInputNumberComponent } from './input.component';
import { SimInputDirective } from './input.directive';

@NgModule({
  declarations: [SimInputDirective, SimTextareaAutosizeDirective, SimInputNumberComponent],
  imports: [CommonModule],
  exports: [SimInputDirective, SimTextareaAutosizeDirective, SimInputNumberComponent]
})
export class SimInputModule {}
